const SESSION_SCOPED_QUERY_KEY = 'session-scoped'

export const queryKeys = {
  sessionScoped: SESSION_SCOPED_QUERY_KEY,
  accountHolders: [SESSION_SCOPED_QUERY_KEY, 'account-holders'],
  transactionStatement: [SESSION_SCOPED_QUERY_KEY, 'transaction-statement'],
  riskAssessment: ['signup/risk-assessment'],
  betAccount: [SESSION_SCOPED_QUERY_KEY, 'bet-account'],
  depositAddCard: [SESSION_SCOPED_QUERY_KEY, 'deposit/add-card'],
  depositInitialData: [SESSION_SCOPED_QUERY_KEY, 'deposit/initial-data'],
  depositGeneratePayId: [SESSION_SCOPED_QUERY_KEY, 'deposit/generate-payid'],
  depositGetBsbDetails: [SESSION_SCOPED_QUERY_KEY, 'deposit/get-bsb-details'],
  withdrawDetails: [SESSION_SCOPED_QUERY_KEY, 'withdraw/withdraw-details'],
  withdrawCreateZeptoContact: [SESSION_SCOPED_QUERY_KEY, 'withdraw/create-zepto-contact'],
  withdrawDeleteZeptoContact: [SESSION_SCOPED_QUERY_KEY, 'withdraw/delete-zepto-contact'],
  withdrawCreateZeptoWithdrawContact: [
    SESSION_SCOPED_QUERY_KEY,
    'withdraw/create-zepto-withdraw-contact',
  ],
  accountSendOtp: [SESSION_SCOPED_QUERY_KEY, 'account/send-otp'],
  accountCountryList: ['account/country-list'],
  accountUserContactDetails: [SESSION_SCOPED_QUERY_KEY, 'account/user-contact-details'],
  signupCreateWageringBetAccount: [SESSION_SCOPED_QUERY_KEY, 'signup/wagering-account'],
  signupApplicationSave: [SESSION_SCOPED_QUERY_KEY, 'signup/application'],
  signupApplicationSubmit: [SESSION_SCOPED_QUERY_KEY, 'signup/application-submit'],
  precommitmentDetails: [SESSION_SCOPED_QUERY_KEY, 'precommitment-page-details'],
  precommitmentDepositLimit: [SESSION_SCOPED_QUERY_KEY, 'precommitment/deposit-limit'],
}

export const toastIds = {
  // Contact details
  contactDetailsSuccess: 'contact-details-success',
  contactDetailsError: 'contact-details-error',
  // Deposit
  addCardSuccess: 'add-card-success',
  addCardError: 'add-card-error',
  defaultCardError: 'default-card-error',
  deleteCardError: 'delete-card-error',
  deleteCardSuccess: 'delete-card-success',
  depositError: 'deposit-error',
  depositSuccess: 'deposit-success',
  payIdActivationSuccess: 'payid-activation-success',
  payIdActivationFailure: 'payid-activation-failure',
  // OTP
  createSendOtpError: 'create-send-otp-error',
  // SignUp
  depositLimitSuccess: 'deposit-limit-success',
  saveDepositLimitFailure: 'save-deposit-limit-failure',
  // Withdrawal
  pendingWithdrawal: 'withdrawal-pending',
  withdrawalError: 'withdrawal-error',
  createZeptoContactError: 'create-zepto-contact-error',
  createZeptoContactSuccess: 'create-zepto-contact-success',
  deleteZeptoContactError: 'delete-zepto-contact-error',
  deleteZeptoContactSuccess: 'delete-zepto-contact-success',
  createZeptoWithdrawContactError: 'create-zepto-withdraw-contact-error',
  createZeptoWithdrawContactSuccess: 'create-zepto-withdraw-contact-success',
  withdrawalChannelChange: 'withdrawal-channel-change',
  // Statements
  activityStatementRequestSuccess: 'activity-statement-request-success',
  activityStatementRequestFailure: 'activity-statement-request-failure',
  transactionStatementDownloadSuccess: 'transaction-statement-download-success',
  transactionStatementDownloadFailure: 'transaction-statement-download-failure',
}

/** Locations needed for CRM wrapper processing */
export enum TABLocation {
  Mobi = 538,
  Desktop = 285,
}

export const routes = {
  blockDebitCard: '/account/block-debit-card',
  personalDetails: '/account/personal-details',
} as const
